import makeStyles from '@mui/styles/makeStyles';
import { largeStartBreakpoint, mobileStartBreakpoint, smallMobileStartBreakpoint } from '@/materialUi/theme';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flexGrow: 1,
    [theme.breakpoints.down(smallMobileStartBreakpoint)]: {
      marginTop: 0
    }
  },
  cardBox: {
    width: '600px'
  },
  img: {
    borderRadius: '10px',
    height: 'auto',
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain',
    backgroundColor: '#000',
    [theme.breakpoints.down(mobileStartBreakpoint)]: {
      width: '100%',
      height: '188px',
      borderRadius: 0,
      backgroundColor: '#fff'
    }
  },
  imageGrid: {
    overflow: 'hidden',
    margin: '10px 0 0 59px',
    minWidth: '448px',
    minHeight: '337px',
    maxHeight: '337px',
    [theme.breakpoints.down(smallMobileStartBreakpoint)]: {
      minHeight: 'auto',
      maxHeight: '188px',
      minWidth: 'auto',
      margin: 0
    },
    [theme.breakpoints.down(largeStartBreakpoint)]: {
      minWidth: '35%'
    }
  },
  buttonContainer: {
    width: '100%',
    [theme.breakpoints.up(mobileStartBreakpoint)]: {
      width: '30%'
    }
  },
  addToOrderContainer: {
    width: '100%',
    height: '40px',
    display: "flex"
  }
}));

export default { useStyles };
